import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const History = () => {
  return (
    <React.Fragment>
      <SEO title=" History | ICSI 2024" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="History"
        content="The Conference"
        contentTwo="History"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
            <div className="history">
          <p>
            <a href="http://www.iasei.org/icsi2024/">
              The Fifteenth International Conference on Swarm Intelligence (ICSI
              2024)
            </a>
            , August 23-26, 2024, Qinghai, China.
          </p>
          <p>
            <a href="http://www.iasei.org/icsi2023/">
              The Fourteenth International Conference on Swarm Intelligence (ICSI
              2023)
            </a>
            , July 14-18, 2023, Shenzhen, China.
          </p>
          <p>
            <a href="http://www.iasei.org/icsi2022/">
              The Thirteenth International Conference on Swarm Intelligence (ICSI
              2022)
            </a>
            , July 15-19, 2022, Xi&apos;an, China (Online Webinar).
          </p>
          <p>
            <a href="http://www.iasei.org/icsi2021/">
              The Twelfth International Conference on Swarm Intelligence (ICSI
              2021)
            </a>
            , July 17-21, 2021, Qingdao, China.
          </p>
          <p>
            <a href="http://www.iasei.org/icsi2020">
              The Eleventh International Conference on Swarm Intelligence (ICSI
              2020)
            </a>
            , July 14-20, 2020, Belgrade, Serbia (Online Webinar).
          </p>
          <p>
            <a href="http://www.iasei.org/icsi2019">
              The Tenth International Conference on Swarm Intelligence (ICSI
              2019)
            </a>
            , July 26-30, 2019, Duangtawan Hotel, Chiang Mai, Thailand.
          </p>
          <p>
            <a href="http://www.iasei.org/icsi2018">
              The Ninth International Conference on Swarm Intelligence (ICSI
              2018)
            </a>
            , June 17-22, 2018, Anting Crowne Plaza Holiday Hotel, Shanghai,
            China.
          </p>
          <p>
            <a href="http://www.iasei.org/icsi2017">
              The Eighth International Conference on Swarm Intelligence (ICSI
              2017)
            </a>
            , July 27-August 01, 2017, JR Hakata City, Fukuoka, Japan.
          </p>
          <p>
            <a href="http://www.iasei.org/icsi2016">
              The Seventh International Conference on Swarm Intelligence (ICSI
              2016)
            </a>
            , June 25-30, 2016, Padma Resort at Legian, Bali, Indonesia.
          </p>
          <p>
            <a href="http://www.iasei.org/icsi2015">
              The Sixth International Conference on Swarm Intelligence (ICSI
              2015)
            </a>
            , June 26-29, 2015, Beijing International Convention Center (BICC),
            Beijing, China.
          </p>
          <p>
            <a href="http://www.ic-si.org/2014">
              The Fifth International Conference on Swarm Intelligence (ICSI
              2014)
            </a>
            , October 17-20, 2014, Best Western Premier Hotel, Hefei, China.
          </p>
          <p>
            <a href="http://2013.ic-si.org/">
              The Fourth International Conference on Swarm Intelligence (ICSI
              2013)
            </a>
            , June 12-15, 2013, New Gloria Garden Plaza Hotel, Harbin, China.
          </p>
          <p>
            <a href="http://2012.ic-si.org/">
              The Third International Conference on Swarm Intelligence (ICSI
              2012)
            </a>
            , June 17-20, 2012, Nan Hai Hotel, Shenzhen, China.
          </p>
          <p>
            <a href="http://2011.ic-si.org/">
              The Second International Conference on Swarm Intelligence (ICSI
              2011)
            </a>
            , June 12-15, 2011, Crowne Plaza Riverside, Chongqing, China.
          </p>
          <p>
            <a href="http://2010.ic-si.org/">
              The First International Conference on Swarm Intelligence
              (ICSI’2010)
            </a>
            , June 12-15, 2010, Lake View Hotel, Beijing, China.
          </p>
          </div>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default History;
